import {StyleSheet} from "aphrodite";
import * as React from "react";

import BaseWithKhanmigoPageTemplate from "./base-with-khanmigo-page-template.tsx";

type Props = {
    children: React.ReactNode;
};

const GuideSidebar = React.lazy(() => import("@khan/guide-ui-sidebar"));

/**
 * Provides the default template for a page on the site, including the header,
 * footer, and main content styles.
 */
const DefaultWithKhanmigoPageTemplate = ({
    children,
}: Props): React.ReactElement => (
    <BaseWithKhanmigoPageTemplate
        showFooter={true}
        containerStyle={styles.wrapper}
        mainContentStyle={styles.mainContent}
        sidebar={
            <React.Suspense fallback={null}>
                <GuideSidebar />
            </React.Suspense>
        }
    >
        {children}
    </BaseWithKhanmigoPageTemplate>
);

const styles = StyleSheet.create({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        minHeight: "unset",
        height: "100%",
    },
    mainContent: {
        flex: "none",
        // NOTE(john): We set the min-height here to be 100vh so that we can push down the
        // footer to below the page fold, preventing as big of a jarring jump when the page
        // loads.
        minHeight: "100vh",
    },
});

export default DefaultWithKhanmigoPageTemplate;
